import Button from 'components/atoms/Button';
import Input from 'components/atoms/Input';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import './styles.scss';

const LoginForm = ({ onSubmit, error }) => {
  const errorClass = classNames({
    loginForm__error: true,
    'loginForm__error--visible': !!error,
  });

  return (
    <form className="loginForm" onSubmit={onSubmit}>
      <Input label="Login" name="login" />
      <Input label="Senha" name="senha" type="password" />
      <div className="loginForm__buttons">
        <Button visual="login">Entrar</Button>
        <Button visual="back" tag={Link} to="/">
          Voltar
        </Button>
      </div>
      <div className={errorClass}>{error}</div>
    </form>
  );
};

export default LoginForm;
